(() => {
  const itemSelector = 'li[data-bt-recommendation-age][data-bt-recommendation-prices][data-bt-recommendation-manual]';
  const validPrice = (price) => price === null || (Number.isSafeInteger(price) && price >= 0);

  // Only the detached response is filtered. Manual choices and the server's order
  // remain intact; no child profile or new recommendations are inferred.
  window.BtFilterRelatedRecommendations = (element, selection) => {
    if (!element || element.tagName !== 'PRODUCT-RECOMMENDATIONS' || element.isConnected ||
        !element.hasAttribute('data-bt-contextual-related') ||
        element.closest('cart-drawer') ||
        element.classList.contains('complementary-products') ||
        element.querySelector('.has-complementary-products') || !selection ||
        !/^[A-Z]{3}$/.test(selection.currency || '') || !/^[A-Z]{2}$/.test(selection.country || '') ||
        element.dataset.btRecommendationCurrency !== selection.currency ||
        element.dataset.btRecommendationCountry !== selection.country ||
        !Array.isArray(selection.ages) || selection.ages.some((age) => typeof age !== 'string') ||
        !validPrice(selection.minPrice) || !validPrice(selection.maxPrice) ||
        (selection.minPrice !== null && selection.maxPrice !== null && selection.minPrice > selection.maxPrice)) return false;

    const byAge = selection.ages.length > 0;
    const byPrice = selection.minPrice !== null || selection.maxPrice !== null;
    if (!byAge && !byPrice) return false;
    const items = Array.from(element.querySelectorAll(itemSelector));
    if (!items.length) return false;
    const lists = new Set(items.map((item) => item.parentElement));

    for (const item of items) {
      if (item.dataset.btRecommendationManual === 'true') continue;
      if (byAge && !selection.ages.includes(item.dataset.btRecommendationAge)) {
        item.remove();
        continue;
      }
      if (byPrice) {
        let prices;
        try { prices = JSON.parse(item.dataset.btRecommendationPrices); } catch (_) { /* Invalid candidate price. */ }
        if (!Array.isArray(prices) || !prices.length || prices.some((price) => !Number.isSafeInteger(price) || price < 0) ||
            !prices.some((price) => (selection.minPrice === null || price >= selection.minPrice) &&
              (selection.maxPrice === null || price <= selection.maxPrice))) item.remove();
      }
    }

    // Include any unannotated list items without filtering them. Other contents
    // never count as products or get removed individually by this helper.
    const count = Array.from(lists).reduce((total, list) => total +
      Array.from(list.children).filter((item) => item.tagName === 'LI').length, 0);
    if (!count) {
      element.innerHTML = '';
      return true;
    }
    element.querySelectorAll('.related-products').forEach((block) => {
      block.classList.toggle('related-products--compact', count <= 2);
    });
    element.querySelectorAll('.slider-counter--total').forEach((counter) => { counter.textContent = String(count); });
    element.querySelectorAll('.slider-counter--current').forEach((counter) => { counter.textContent = '1'; });
    element.querySelectorAll('[data-num-slides], .slider-scrollbar__track').forEach((track) => {
      track.dataset.numSlides = String(count);
      track.style.setProperty('--num-slides', String(count));
    });
    return true;
  };
})();
